import * as React from "react";
import { ActionIcon, Group, Text } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { ChevronLeft, ChevronRight } from "tabler-icons-react";
import {
	_defaultCopyright,
	_defaultImpressum,
	_defaultPrivacyPolicy,
	_mobileWidth,
} from "../constants";

interface Props {
	sidebarMinimized: boolean;
	toggleSidebarMinimized: () => void;
	disclaimer: string | undefined;
	privacyPolicy: string | undefined;
	copyright: string | undefined;
}

export default function _Footer({
	sidebarMinimized,
	toggleSidebarMinimized,
	copyright,
	disclaimer,
	privacyPolicy,
}: Props) {
	const mobile = useMediaQuery(`(max-width: ${_mobileWidth}px)`);
	return (
		<Group position="apart" p={0} align="center" style={{ height: "100%" }}>
			{mobile ? (
				<div />
			) : (
				<Group>
					<ActionIcon
						variant="default"
						onClick={() => toggleSidebarMinimized()}
						size={30}
					>
						{sidebarMinimized ? (
							<ChevronRight size={15} />
						) : (
							<ChevronLeft size={15} />
						)}
					</ActionIcon>
					{sidebarMinimized ? undefined : <Text>Collapse Sidebar</Text>}
				</Group>
			)}
			<Group position="apart">
				<Text size="xs" color={"gray"}>
					{copyright}
				</Text>
				<Group>
					<div className={""}>
						<a href={privacyPolicy}>
							<Text size="xs">Privacy Policy</Text>
						</a>
					</div>{" "}
					<div className={""}>
						<a href={disclaimer}>
							<Text size="xs">Impressum</Text>
						</a>
					</div>
				</Group>
			</Group>
		</Group>
	);
}
